module.exports = __webpack_public_path__ + "static/media/27OCHA4.e48eeb9c.jpg";